import { useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';

interface UseScrollPositionProps {
    saveScrollPosition: boolean;
}

export const useScrollPosition = ({
    saveScrollPosition,
}: UseScrollPositionProps): { readonly current: number } => {
    const scrollPosition = useRef(0);

    useEffect(() => {
        if (!saveScrollPosition) {
            return undefined;
        }

        const updateState = (): void => {
            if (window.scrollY > 0) {
                scrollPosition.current = window.scrollY;
            }
        };

        const handleScroll = (): void => {
            updateState();
        };

        const throttleHandleScroll = throttle(handleScroll, 300);

        const addScrollListener = (): void => {
            if ('onscrollend' in window) {
                window.addEventListener('scrollend', handleScroll);
            } else {
                (window as Window).addEventListener('scroll', throttleHandleScroll);
            }
        };

        const clearScrollListener = (): void => {
            if ('onscrollend' in window) {
                window.removeEventListener('scrollend', handleScroll);
            } else {
                (window as Window).removeEventListener('scroll', throttleHandleScroll);
            }
        };

        addScrollListener();

        return () => {
            clearScrollListener();
        };
    }, [saveScrollPosition]);

    return scrollPosition;
};
